import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import CheckCircleIcon from 'components/material-symbol/icons/CheckCircleOutline'
import RouterLinkButton from 'components/router-link-button'
import { useStyles } from './styles'
import { REQUESTS_PATH } from './utils'
import { trackVirtualCoachingPurchaseComplete } from './analytics'

// Stripe returned the golfer but the request is not available to load yet (the
// backend creates it from Stripe's webhook, and a payment the webhook cancels
// can still land here after the timeout). The copy promises only what is
// known: we have the payment details, the request appears in Virtual Coaching
// once the payment is confirmed, and the email is the next step.
const PurchaseFallback = ({ purchaseStatus }) => {
  const classes = useStyles()

  // The page's `complete-checkout` event needs the loaded request, which this
  // path doesn't have, so count the sale here, but only once Stripe says the
  // payment is complete (not while it is still `processing` or `unverified`).
  useEffect(() => {
    if (purchaseStatus === 'complete') trackVirtualCoachingPurchaseComplete()
  }, [purchaseStatus])

  return (
    <Box
      className={clsx(classes.narrowPage, classes.confirmPage)}
      data-testid="virtual-coaching-fallback"
    >
      <Box className={classes.confirmHero}>
        <Box
          className={clsx(classes.confirmIcon, classes.confirmIconSuccess)}
          aria-hidden="true"
        >
          <CheckCircleIcon />
        </Box>
        <Typography variant="h1" className={classes.confirmTitle}>
          Payment Details Received
        </Typography>
        <Typography className={clsx(classes.muted, classes.confirmSubtitle)}>
          We received your payment details. Your request will appear in Virtual
          Coaching once your payment is confirmed, and we&apos;ll email you a
          link to upload your videos.
        </Typography>
      </Box>
      <Box className={classes.centerAction}>
        <RouterLinkButton
          variant="contained"
          color="primary"
          size="large"
          to={REQUESTS_PATH}
        >
          Go to Virtual Coaching
        </RouterLinkButton>
      </Box>
    </Box>
  )
}

PurchaseFallback.propTypes = {
  purchaseStatus: PropTypes.string,
}

export default PurchaseFallback
